import React, { ReactNode } from "react";

import { IntlShape } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import styles from "./getDescriptionWithActionsNode.module.scss";

export type DescriptionArgs = {
  actionTitle?: ReactNode;
  description: string;
  intl: IntlShape | undefined;
  onActionClick?: () => void;
  onCloseClick?: () => void;
};

const getDescriptionWithActionsNode = ({
  actionTitle,
  description,
  intl,
  onActionClick,
  onCloseClick,
}: DescriptionArgs) => (
  <div className={styles.container}>
    <div>{description}</div>
    {(onCloseClick || onActionClick) && (
      <div className={styles.actions}>
        {onCloseClick && (
          <Button onClick={onCloseClick}>
            {intl?.formatMessage({
              id: "notification.description.actions.close",
              defaultMessage: "Close",
              description: "Close option in the notification",
            }) ?? "Close"}
          </Button>
        )}
        {onActionClick && (
          <Button onClick={onActionClick} type="primary">
            {actionTitle ??
              intl?.formatMessage({
                id: "notification.description.actions.view",
                defaultMessage: "View",
                description: "View option in the notification",
              }) ??
              "View"}
          </Button>
        )}
      </div>
    )}
  </div>
);

export default getDescriptionWithActionsNode;
